import { all, fork } from 'redux-saga/effects';

import { aboutSaga } from './aboutSaga';
import { photosSaga } from './photosSaga';
import { packageSaga } from './packageSaga';
import { videosSaga } from './videosSaga';
import { contactSaga } from './contactSaga';

function* rootSaga() {
	yield all([
		fork(aboutSaga),
		fork(photosSaga),
		fork(packageSaga),
		fork(videosSaga),
		fork(contactSaga)
	]);
}

export default rootSaga;


// WEBPACK FOOTER //
// ./src/sagas/rootSaga.js